<template>
  <div class="rewRoules">
    <div class="returnButton" @click="goBack">
      <i class="el-icon-arrow-left"></i>
      返回
    </div>
    <!-- 提交表单 -->
    <div class="form-box">
      <div class="box">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-position="top"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="规则名称" prop="ruleName">
            <el-input
              type="text"
              placeholder="请填写规则名称 "
              v-model="ruleForm.ruleName"
              maxlength="30"
              clearable
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="推送时间" prop="ruleType">
            <el-select v-model="ruleForm.ruleType" placeholder="请选择推送时间" clearable>
              <el-option
                v-for="item in typelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推送内容" class="push-content" prop="articleId">
            <span v-if="articleObj.articleId" class="push-content-title" @click="chouseTitle">
              替换内容
            </span>
            <span v-else class="push-content-title" @click="chouseTitle">选择内容</span>
            <el-input type="text" style="display: none" v-model="ruleForm.articleId"></el-input>
            <div class="article-edit">
              <div class="article-edit-left">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="articleObj.articleCoverListUrl"
                  fit="contain"
                >
                  <div slot="error" class="image-slot"></div>
                </el-image>
              </div>
              <div class="article-edit-right">
                <span>{{ articleObj.articleTitle }}</span>
                <span>{{ articleObj.articleId }}</span>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="footer">
          <el-button @click="CloseDialog">取 消</el-button>
          <el-button type="primary" @click="confirmAction">保存</el-button>
        </div>
      </div>
    </div>
    <Dialog
      title="选择内容"
      :visible="chouseVisible"
      width="800px"
      :show-dialog-footer="false"
      @handleClose="chouseCloseDialog"
    >
      <template slot>
        <titleList
          ref="titleLists"
          @chouseAction="chouseAction"
          @chouseCloseDialog="chouseCloseDialog"
          :id="chousedArticleId"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import { EditPublishRule, SelectRuleInfo, FindPushDateType } from '../../../api/pointsRule.js';
import Dialog from '../../../components/dialog/index';
import titleList from '../component/titleList/index';
const { rules } = require('./index');
export default {
  name: 'OperationManageEdit',
  components: { Dialog, titleList },
  data() {
    return {
      ruleForm: {
        id: '', // 规则ID
        agentId: '', // 企业应用ID
        articleId: '', // 企业微信文章id
        ruleType: '', // 规则类型
        ruleName: '', // 规则名称
      },
      typelist: [],
      chouseVisible: false, // 弹窗展示
      articleObj: {}, // 选中的文章内容
      rules, // 校验规则
      chousedArticleId: 0,
      breadcrumb: [
        {
          menu_name: '发布管理',
        },
        {
          menu_name: '新员工推送',
        },
        {
          menu_name: '推送规则',
          menu_path: 'huizhi_EmployeeMaintenance',
        },
      ],
    };
  },
  watch: {
    $route: {
      handler(route) {
        const { id } = route.query;
        if (id) {
          this.getRuleDel();
        }
      },
      // 深度观察监听
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getTypeList();
    this.breadcrumb.push({ menu_name: this.$route.query.id ? '编辑规则' : '新建规则' });
    this.g_breadcrumb(this.breadcrumb);
  },
  methods: {
    getTypeList() {
      // 获取后端返回推送配置时间，存到Vuex
      FindPushDateType({ id: 1 })
        .then((res) => {
          const data = res?.dateList;
          this.typelist = [];
          data.forEach((item) => {
            const obj = {
              label: '',
              value: '',
            };
            obj.label = `入职第${item}天`;
            obj.value = item;
            this.typelist.push(obj);
          });
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 根据id获取规则详情
    getRuleDel() {
      const params = {
        id: this.$route.query.id,
      };
      SelectRuleInfo(params)
        .then((res) => {
          const { id, agentId, articleId, ruleType, ruleName } = res;
          this.ruleForm.id = id;
          this.ruleForm.agentId = agentId;
          this.ruleForm.articleId = articleId;
          this.ruleForm.ruleType = ruleType;
          this.ruleForm.ruleName = ruleName;
          this.chousedArticleId = articleId;
          this.articleObj = res;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 弹窗确认
    confirmAction() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.$route.query.id) {
            // 新建
            EditPublishRule(this.ruleForm)
              .then((res) => {
                if (res.err_code === 1) {
                  this.$message({
                    message: '新建成功',
                    type: 'success',
                  });
                  this.CloseDialog();
                } else {
                  this.$message({
                    message: res.err_msg,
                    type: 'error',
                  });
                }
              })
              .catch((res) => {
                this.$message({
                  message: res.message,
                  type: 'error',
                });
                console.log(res.message);
              });
          } else {
            // 编辑
            EditPublishRule(this.ruleForm)
              .then((res) => {
                if (res.err_code === 1) {
                  this.$message({
                    message: '编辑成功',
                    type: 'success',
                  });
                  this.CloseDialog();
                } else {
                  this.$message({
                    message: res.err_msg,
                    type: 'error',
                  });
                }
              })
              .catch((res) => {
                this.$message({
                  message: res.err_msg,
                  type: 'error',
                });
              });
          }
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    // 选择文章
    chouseTitle() {
      this.chouseVisible = true;
      this.$nextTick(() => {
        this.$refs.titleLists.getTitleList();
      });
    },
    // 关闭文章选择弹窗
    chouseCloseDialog() {
      this.chouseVisible = false;
      this.$refs.titleLists.resetPreans();
    },
    // 确认选择弹窗确认事件
    chouseAction(val) {
      this.chouseVisible = false;
      this.articleObj = { ...val };
      this.ruleForm.agentId = val.agentID;
      this.ruleForm.articleId = val.articleId;
    },
    // 弹窗关闭
    goBack() {
      this.CloseDialog();
    },
    // 弹窗关闭
    CloseDialog() {
      this.$refs.ruleForm.resetFields();
      this.g_tourl(`/saas/huizhi/EmployeeMaintenance.html`);
    },
  },
};
</script>
<style lang="scss" scoped>
.rewRoules {
  .returnButton {
    cursor: pointer;
    margin: 16px 0;
  }
  .form-box {
    padding: 24px;
    background: #f7f9fc;
    .box {
      background: #fff;
      padding: 21px 0px 24px 16px;
      width: 100%;
      .demo-ruleForm {
        margin-left: 30px;
      }
      .footer {
        margin: 100px 0px 0px 30px;
      }
    }
  }
  .push-content {
    position: relative;
  }
  .push-content-title {
    position: absolute;
    top: -50px;
    left: 80px;
    color: cornflowerblue;
    cursor: pointer;
  }
  .article-edit {
    display: flex;
    .article-edit-right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 12px;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 0px;
  }
  ::v-deep .el-dialog .el-dialog__header {
    border-bottom: 0px solid #edeff2;
  }
  ::v-deep .el-form-item__content {
    .el-input {
      width: 400px;
      max-width: 400px;
    }
    .el-input__inner {
      height: 36px;
    }
  }
  ::v-deep .el-radio-group {
    display: flex;
    // justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    text-align: left;
    width: 600px;
    .el-radio {
      margin: 13px 5px;
      text-align: left;
      width: 94px;
    }
  }
  ::v-deep .el-form-item__label {
    text-align: left;
  }
  ::v-deep .el-button {
    width: 100px;
    height: 36px;
  }
}
</style>
